// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addMarginBottom {
  margin-bottom: 15px;
}

.firstLine a {
  font-size: 12px;
  margin-right: 10px;
  color: black !important;
  font-weight: 400 !important;
}

.secondLine {
  font-size: 12px;
  margin-right: 10px;
  color: black !important;
}

ul {
  list-style: none;
  padding: 0px !important;
  display: flex;
}

.item-list {
  display: flex;
}

.login-description {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: black !important;
  width: 100%;
}

.login-padding {
  padding: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/content/layout/components/modals/login-modal/login-modal.component.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,uBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;AAAF","sourcesContent":["\n.addMarginBottom {\n  margin-bottom: 15px;\n}\n\n.firstLine a {\n  font-size: 12px;\n  margin-right: 10px;\n  color: black !important;\n  font-weight: 400 !important;\n}\n\n.secondLine {\n  font-size: 12px;\n  margin-right: 10px;\n  color: black !important;\n}\n\nul {\n  list-style: none;\n  padding: 0px !important;\n  display: flex;\n}\n\n.item-list {\n  display: flex;\n}\n\n.login-description {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: black !important;\n  width: 100%;\n}\n\n.login-padding {\n  padding: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
